import React from "react";

import { graphql, useFragment } from "react-relay";

import { IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher$key } from "./__generated__/IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher.graphql";
import { IntegrationTextItem } from "./components/IntegrationAddItem";

export function IntegrationAdminIcaMinButikListItemListItem(props: {
  isFirst: boolean;
  isLast: boolean;
  integration: IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher$key;
  onPress: () => void;
}) {
  const integration = useFragment(
    graphql`
      fragment IntegrationAdminIcaMinButikListItem_IntegrationWebFetcher on ICAMinButikIntegration {
        __typename
        status
      }
    `,
    props.integration
  );
  return (
    <IntegrationTextItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={() => {
        props.onPress();
      }}
      mode={integration.status === "ACTIVE" ? "positive" : "loading"}
    >
      ICA Min Butik
    </IntegrationTextItem>
  );
}
